<template>
  <div class="cost">
    <div class="cost-top">
      <div class="cost-top__title">选品成本与费用</div>
      <div class="cost-top__right">
        <div class="cost-top__fun">
          <el-select class="cost-top__input" size="mini" placeholder="全部店铺"></el-select>
          <el-select class="cost-top__input" size="mini" placeholder="国家站点"></el-select>
          <el-select class="cost-top__input" size="mini" placeholder="预选及在售"></el-select>
          <el-input class="cost-top__input cost-top__input--text" size="mini" placeholder="请输入产品型号/名称/ASIN"></el-input>
        </div>
        <div class="cost-top__btn">搜索</div>
        <div class="cost-top__btn">查看各分项成本与费用占比</div>
        <div class="cost-top__btn">销售汇总及分摊</div>
      </div>
    </div>
    <div class="cost-table">
      <Table
        :head="tableHead"
        :body="profitCostList"
        width="1654"
        height="550"></Table>
    </div>
  </div>
</template>

<script>
import Table from 'components/common/Table.vue'
import { ProductProfitNewModule } from './class'
export default {
  name: 'costOfGoods',
  components:{ Table },
  data(){
    return {
      /**表头 */
      tableHead: ProductProfitNewModule.NEWCOSTTABLEHEAD(),
      profitCostList: []
    }
  }
}
</script>

<style lang="scss" scoped>
.cost{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    &__title{
      color: black;
      font-weight: bold;
      font-size: 16px;
    }
    &__right{
      display: flex;
      align-items: center;
      ::v-deep{
        .el-input__inner{
          width: 120px;
        }
      }
    }
    &__fun{
      display: flex;
    }
    &__input{
      margin: 0 5px;
      &--text{
        ::v-deep{
          .el-input__inner{
            width: 180px;
          }
        }
      }
    }
    &__btn{
      padding: 6px 20px;
      background: #00a0c7;
      color: white;
      margin-left: 5px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
